import React, { useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { LOGIN_ROUTE_PATH } from "../app_utils/route_paths/resolver/PageRoutes";
import { BaseApiServiceImpl } from "../app_utils/api/BaseApiServiceImpl";
import { MessageUtils } from "../app_utils/utils/MessageUtils";
import { Messages } from "primereact/messages";

const VerifyOtp = () => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const history = useHistory();
  const message = useRef<any>();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const emailParam = params.get("email");
    if (emailParam) {
      setEmail(emailParam);
    }
  }, []);

  const verifyOtp = () => {
    if (!email.trim() || !otp.trim()) {
      MessageUtils.showErrorMessage(message, "Please enter both email and OTP");
      return;
    }

    setIsVerifying(true);
    new BaseApiServiceImpl("/api/v1/auth/verify-otp")
      .postRequestWithJsonResponse({ emailAddress: email, otp })
      .then(() => {
        setIsVerifying(false);
        setIsVerified(true);
        MessageUtils.showSuccessMessage(message, "Account verified successfully! You can now log in.");
      })
      .catch((error) => {
        setIsVerifying(false);
        MessageUtils.showErrorMessage(message, error.message);
      });
  };

  const resendOtp = () => {
    if (!email.trim()) {
      MessageUtils.showErrorMessage(message, "Please enter your email address");
      return;
    }

    setIsSending(true);
    new BaseApiServiceImpl("/api/v1/auth/send-otp")
      .postRequestWithJsonResponse({ emailAddress: email })
      .then(() => {
        setIsSending(false);
        MessageUtils.showSuccessMessage(message, "OTP sent successfully. Please check your email.");
      })
      .catch((error) => {
        setIsSending(false);
        MessageUtils.showErrorMessage(message, error.message);
      });
  };

  const goToLogin = () => {
    history.replace(LOGIN_ROUTE_PATH);
  };

  if (isVerified) {
    return (
      <div
        className="login-page flex flex-column"
        style={{
          background: "linear-gradient(to right, #4b79a1, #283e51)",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          className="login-panel card shadow-lg p-4 rounded-lg"
          style={{ maxWidth: "450px", width: "100%" }}
        >
          <div className="text-center mb-4">
            <i className="pi pi-check-circle" style={{ fontSize: "4rem", color: "#22c55e" }}></i>
            <h2 style={{ color: "#283e51", marginTop: "1rem" }}>Verification Successful!</h2>
            <p className="text-muted">
              Your account has been verified. You can now log in.
            </p>
          </div>
          <Button
            className="p-button-rounded p-button-primary w-full mt-3"
            label="GO TO LOGIN"
            onClick={goToLogin}
            style={{
              backgroundColor: "#4b79a1",
              border: "none",
              width: "100%",
              fontSize: "1.1rem",
              padding: "0.75rem",
            }}
          />
        </div>
      </div>
    );
  }

  return (
    <div
      className="login-page flex flex-column"
      style={{
        background: "linear-gradient(to right, #4b79a1, #283e51)",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem 0",
      }}
    >
      <div
        className="login-panel card shadow-lg p-4 rounded-lg"
        style={{ maxWidth: "450px", width: "100%" }}
      >
        <div className="text-center mb-4">
          <h2 style={{ color: "#283e51" }}>Verify Your Account</h2>
          <p className="text-muted">Enter the OTP sent to your email</p>
        </div>

        <Messages ref={message} style={{ width: "100%" }} />

        <div className="grid">
          <div className="col-12">
            <label htmlFor="email" className="block mb-2">Email Address</label>
            <div className="p-inputgroup">
              <span className="p-inputgroup-addon">
                <i className="pi pi-envelope"></i>
              </span>
              <InputText
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                style={{ width: "100%" }}
              />
            </div>
          </div>

          <div className="col-12">
            <label htmlFor="otp" className="block mb-2">One-Time Password (OTP)</label>
            <div className="p-inputgroup">
              <span className="p-inputgroup-addon">
                <i className="pi pi-lock"></i>
              </span>
              <InputText
                id="otp"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter OTP"
                style={{ width: "100%" }}
              />
            </div>
          </div>
        </div>

        <Button
          loading={isVerifying}
          className="p-button-rounded p-button-primary w-full mb-3 mt-3"
          label="VERIFY ACCOUNT"
          onClick={verifyOtp}
          style={{
            backgroundColor: "#4b79a1",
            border: "none",
            width: "100%",
            fontSize: "1.1rem",
            padding: "0.75rem",
          }}
        />

        <div className="text-center mt-3">
          <p className="text-muted">
            Didn't receive the OTP?{" "}
            <button
              onClick={resendOtp}
              disabled={isSending}
              style={{
                background: "none",
                border: "none",
                color: "#4b79a1",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              {isSending ? "Sending..." : "Resend OTP"}
            </button>
          </p>
        </div>

        <div className="text-center mt-3">
          <p className="text-muted">
            Already verified?{" "}
            <button
              onClick={goToLogin}
              style={{
                background: "none",
                border: "none",
                color: "#4b79a1",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Login
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerifyOtp;